import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { ModalContainer } from '../containers/ModalContainer.js';

const MiniCartModal = (props)=>{
    return /*#__PURE__*/ React.createElement(ModalContainer, swcHelpers.extends({}, props));
};

export { MiniCartModal };
//# sourceMappingURL=MiniCartModal.js.map
